import { render, staticRenderFns } from "./Unavailable.vue?vue&type=template&id=c2338280&scoped=true&"
import script from "./Unavailable.vue?vue&type=script&lang=js&"
export * from "./Unavailable.vue?vue&type=script&lang=js&"
import style0 from "./Unavailable.vue?vue&type=style&index=0&id=c2338280&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2338280",
  null
  
)

export default component.exports